import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import axios from 'axios';

/**
 * gets sessionid props from MarketOrders
 * this component checks (StartSim/ready) and conditionally renders the start button accordingly
 */
class StartButton extends Component {

    constructor(props) {
        //console.log("StartButton constructor");
        super(props);
        this.state = {
            isPaused: true,
            ready: false,
            canStart: true,
            clicked: false,
            serverReady: false,
            serverIP: ''
        };
        this.start = this.start.bind(this);
        this.pause = this.pause.bind(this);
    }

    /**
     * deals with starting and restarting a session
     */
    start() {
        console.log("StartButton start");
        const simStateRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim');
        simStateRef.child("Trigger").set(true);
        simStateRef.child("State").set("Running");
        /*let that = this;
        axios.get(`http://${this.state.serverIP}/run/${this.props.institution}/${this.props.sessionid}`).then(
          (res)=>{
            console.log("response:",res);
            that.setState({
                isPaused: false,
                clicked: true
            })
        });*/
        //console.log("true");
    }

    /**
     * deals with pausing a session
     */
    pause() {
        //console.log("StartButton pause");
        const simStateRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim');
        this.setState({
            isPaused: false
        });
        //console.log("Changing state of running to 'Paused'");
        simStateRef.child("running").remove().then(function () {
            simStateRef.child("start").set(false);
        }).then(function () {
            simStateRef.child("State").set("Paused");
        });
    }

    componentDidMount() {
        //console.log("StartButton componentDidMount");
        //console.log(this.props);
        var that = this;

        this.creatorRef = this.props.db.child("PlayableSessions").child(this.props.sessionid).child("Creator");
        this.serverRef = this.props.db.parent.child('servers').child(this.props.institution).child(this.props.sessionid);
        this.serverRef.on("value", snap =>{
          let data = snap.val();
          if (!data){
            console.log("nothing yet");
            return;
          }
          console.log("READING SERVER DATA", data);
          if (data.hasOwnProperty("status")){
            let status = data.status;
            if (status == "ready"){
              that.setState({
                serverReady: true
              });
            }
          }
        });
        this.creatorRef.once("value").then(snap => {
            if (this.props.uid === snap.val()) {
                //console.log(this.props.uid, snap.val())
                this.setState({
                    canStart: true
                })
            } else {
                this.setState({
                    canStart: false
                })
            }
        });

        this.buttonStateRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim').child('Ready');
        this.buttonStateRef.on('value', snap => {
            if (snap.val()) {
                this.setState({
                    isPaused: false,
                    ready: true
                })
            }
        })


    }

    componentWillUnmount() {
        //console.log("StartButton componentWillUnmount");
        this.buttonStateRef.off();
        this.serverRef.off();
        //console.log("Unmounting");
        this.setState({
            isPaused: false,
            ready: true
        });
    }

    render() {
        return (
            <button
                onClick={this.start}
                className={`start-button ${!this.props.isReady && this.state.clicked ? 'waiting' : ''}`}
                disabled={!(this.state.ready && this.state.canStart && this.state.serverReady) || (this.props.isReady && this.state.serverReady)}>
                Start
            </button>);
    }
}

StartButton.propTypes = {
    sessionid: PropTypes.string
};

export default StartButton;



// WEBPACK FOOTER //
// ./src/components/Orderbook/Buttons.js